import React, { useEffect, useRef } from "react";
import "./categories.css";
import { FaGlobe, FaHandshake, FaBalanceScale, FaLaptopCode, FaBriefcase, FaIndustry, FaUsers, FaRocket, FaHome, FaGavel } from "react-icons/fa";

const practiceAreas = [
  { icon: <FaGlobe />, title: "Foreign Collaborations" },
  { icon: <FaHandshake />, title: "Joint Ventures and Strategic Partnerships" },
  { icon: <FaBalanceScale />, title: "Corporate Law" },
  { icon: <FaLaptopCode />, title: "Information Technology" },
  { icon: <FaBriefcase />, title: "Business Ventures" },
  { icon: <FaIndustry />, title: "MSME" },
  { icon: <FaUsers />, title: "Mediation and Dispute Resolution" },
  { icon: <FaRocket />, title: "Start-up India Initiatives" },
  { icon: <FaHome />, title: "Property and Real Estate" }
];

const Categories = () => {
  const boxRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    boxRefs.current.forEach((box) => {
      if (box) observer.observe(box);
    });

    return () => {
      boxRefs.current.forEach((box) => {
        if (box) observer.unobserve(box);
      });
    };
  }, []);

  return (
    <section className="practice-areas">
      <div className="containe">
        {/* Left Side - Text */}
        <div className="text-section">
          <div className="title-wrapper">
           <span className="icon-bg">
                           <FaGavel />
                         </span>
            <h2>General & Legal <span>Practice Areas</span></h2>
          </div>
          <p>We provide expert legal services across various domains to protect your business and personal interests.</p>
        </div>

        {/* Right Side - Grid */}
        <div className="grid-section">
          {practiceAreas.map((area, index) => (
            <div
              key={index}
              className="area-box fade-in"
              ref={(el) => (boxRefs.current[index] = el)}
              style={{ transitionDelay: `${index * 0.2}s` }}
            >
              <div className="icon">{area.icon}</div>
              <h3>{area.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;